import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue";
import TableBase from "./TableBase.vue";
import { $get } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";
import { CheckApprovalOvertimeWork } from "@/models/approval/ApprovalResponse";
import OverworkExpandItem from "../expand/OverworkExpandItem.vue";

type Props = {
  shiftId: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'OverworkDialogTable',
  props: {
    shiftId: null
  },
  setup(__props: any) {

const props = __props as {
  shiftId: string;
};



const items = ref<CheckApprovalOvertimeWork[]>([]);

const getItems = async () => {
  const response = await $get<CheckApprovalOvertimeWork[]>(
    `${Paths.approval.shiftTable.overwork}/${props.shiftId}`
  );
  if (response) items.value = response;
};

watch(
  () => props.shiftId,
  async () => {
    await getItems();
  },
  { immediate: true }
);

return { __sfc: true,props, items, getItems, TableBase, OverworkExpandItem }
}

})